// Google Maps embed v jazyku stranky.
//
// URL vklada kazda prevadzka sama (companies.google_maps_url), zvycajne skopirovanu
// z "Zdielat -> Vlozit mapu" v anglickom prehliadaci -- potom je ovladanie mapy
// anglicky ("Open in Maps", "Use ctrl + scroll to zoom the map"). Jazyk je v URL
// na dvoch miestach a opravujeme oba:
//   - parameter `hl` (stary format maps.google.com/maps?...&output=embed),
//   - segmenty `!3m2!1s<jazyk>!2s<krajina>` (a `!5m2!…`) v `pb` (format /maps/embed?pb=...),
//     ktore maju pred `hl` prednost.
// Ine `!1s` v `pb` (napr. ID miesta `!1s0x...`) sa nemenia -- regex chyti len
// segmenty za `!3m2` / `!5m2`.
//
// Ide sa cez retazec, nie cez URLSearchParams: ten by pri serializacii prekodoval
// `!` v `pb` na `%21` a menit kodovanie cudzej URL nechceme.

const PB_JAZYK = /(![35]m2!1s)[a-zA-Z]{2,3}(?:-[a-zA-Z]{2,4})?(!2s)/g;
const HL = /([?&])hl=[^&#]*/;

export function lokalizujMapu(url, jazyk = "sk") {
  if (!url) return "";
  let vysledok = url.replace(PB_JAZYK, `$1${jazyk}$2`);
  if (HL.test(vysledok)) return vysledok.replace(HL, `$1hl=${jazyk}`);

  const [bezHash, ...hash] = vysledok.split("#");
  vysledok = `${bezHash}${bezHash.includes("?") ? "&" : "?"}hl=${jazyk}`;
  return hash.length ? `${vysledok}#${hash.join("#")}` : vysledok;
}
